import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrWorkspaceDeveloperEnvironment.ts
var t = () => e("workspaceDeveloperEnvironment");
//#endregion
export { t as useTrWorkspaceDeveloperEnvironment };
